module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAyklEQVRYhe3UMQrCMBSA4b8lOHsKnR3EwQs4VVycRHcHcaincPACTuLc4hFE3MXjCKKDbanCGxoDyfB+CGR54YOEREma9YEj0KFZD2APrIBnw9mq03ZS7WNLCEALWAJTW8hvsSWkXtcFBD6YYDIOzhgBbdvh8SZ/AXfg4AIzKNa/DUO6pkVIGBMSBgP0fCPKDHDzCaj/wFGSZmuPlq8MsPONKAvqAStGSjFSipFSjJRipBQjpRgpxUgpRio4zNU3ougcAzP8gy7A/A0A8xc4tXqXJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/introduction_icon_outline.png
// module id = nH5p
// module chunks = 0